import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router v6 (non-data router) preserves the previous window scroll
// across `navigate()` calls, so jumping from a long page (e.g. Dashboard)
// to a shorter target leaves the new page rendered mid/bottom. This
// listener resets scroll on every pathname change. Hash anchors are
// excluded so the browser's native anchor scroll still works (the Account
// page deep-links via `#bank-details`, `#legal-notice`, `#booking-page`).
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
